export default __webpack_public_path__ + "static/media/stop-icon.dc88a30c.svg";